import "/src/styles/fonts.css";
import "/src/styles/global.scss";
import "/src/styles/slick-newsroom.scss";
import "/src/styles/hubspot.scss";
require("prismjs/themes/prism-solarizedlight.css");
require("prismjs/themes/prism-okaidia.css");

import { initTrackers } from "./src/utils/analytics";

let analyticsAllowed = false;

export const onClientEntry = () => {
  window._hsp = window._hsp || [];

  window._hsp.push([
    "addPrivacyConsentListener",
    (consent) => {
      analyticsAllowed = Boolean(consent?.categories?.analytics);
      if (analyticsAllowed) {
        initTrackers();
      }
    },
  ]);
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (
    analyticsAllowed &&
    prevLocation &&
    typeof window !== "undefined" &&
    window.gtag
  ) {
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search + location.hash,
    });
  }
};
